import React from 'react';
import { Modal, Button } from "react-bootstrap";
import { apiDeleteView } from '../../../api/ApiView';

const ModalDeleteView = (props) => {
    const { id, show, handleClose, handleRecupDatas } = props;

    const submitData = async () => {
        await apiDeleteView(id);
        handleRecupDatas();
        handleClose();
      };

    return (
        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Supprimer une vue</Modal.Title>
        </Modal.Header>
        <Modal.Body>Vous souhaitez vraiment supprimer cette vue ?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="success" onClick={submitData}>
            Confimer la suppression
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

export default ModalDeleteView;